/* eslint-disable import/prefer-default-export */
/* eslint-disable camelcase */
import {
    LOW_DEMAND_MODE,
    TYPE_B,
} from "const"
import { SilResultSubsystem } from "server/models"
import { LangType } from "client/store"

import * as Formulas from ".."


export const iec_61511_2016_architecturalConstraints = (
    redundancy: boolean,
    subsystem: SilResultSubsystem,
    lang: LangType,
) => {
    if (redundancy) {
        const hft = Formulas.getHFT(subsystem.architecture)
        const device = subsystem.blocks[0].projectDevice
        const {
            sil,
            type,
            failureRate,
            provenInUse,
            dd,
            du,
        } = device
        const mode = Formulas.getSilMode(device)

        const dc = failureRate
            ? Formulas.dc({ dd, du })
            : Formulas.parseProp(device.dc)

        if (sil) return lang[`sil_${sil}`]

        if (provenInUse) { // this is route 2h
            if (type === TYPE_B && dc < 0.6) return lang.notCompliant
            if (hft >= 2) return lang.sil_4
            if (hft >= 1) return lang.sil_3
            if (hft >= 0 && mode === LOW_DEMAND_MODE) return lang.sil_2
            if (hft >= 0) return lang.sil_1
            return lang.notCompliant
        }
        return lang.notCompliant
    }
    return lang.notCompliant
}
